import Vue from 'vue'

//vuex
import store from '../stores'

//sleep 処理
window.sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

//plugins
import WindowStatePlugin from '../plugins/windowstate'

//components
import CardForm from '../components/card_form.vue'
import SubscribeInit from '../components/registers/subscribe_init.vue'
import PlanSelectRegister from '../components/registers/plan_select_register.vue'
import GoogleOauthBtn from '../components/registers/google_oauth_btn.vue'

//library
import BootstrapVue from 'bootstrap-vue'

Vue.use(require('vue-cookies'))
Vue.use(BootstrapVue)

const app = new Vue({
  el: '#login_vue_app',
  store,
  components: {
    CardForm,
    SubscribeInit,
    PlanSelectRegister,
    GoogleOauthBtn,
  },
  methods: {
    async subscribeToPlan(token){
      //console.log(token)
      try{
        await this.$store.dispatch("user/createSubscription", token)
        this.$cookies.remove("register_plan_name")
        this.$bvModal.show('subscribe_thx')
        setTimeout(function(){
          location.href="/users"
        }, 5000)
      } catch(e){
        alert("利用できないカードです。別のカードをご利用ください");
        this.$store.commit("user/offSubmittingCard")
      }
    },
  },
  async mounted(){
    await Vue.nextTick()
  }
})
window.vue_app = app
